import styled from "styled-components";
import { Placeholder } from "react-bootstrap";

export const PlaceholderContainer = styled(Placeholder)`
  flex: 1;
`;
